import { render, staticRenderFns } from "./ObservacionesCard.vue?vue&type=template&id=5342f463"
import script from "./ObservacionesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ObservacionesCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports